export default __webpack_public_path__ + "static/media/chair.456e48f4.svg";